import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { CONFIGURATIONS_PATH } from './paths'
import PropTypes from 'prop-types'

function PublicRoute ({ component: Component, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => !isAuthenticated ? <Component {...props} /> : <Redirect to={{ pathname: CONFIGURATIONS_PATH }} />}
    />
  )
}
PublicRoute.propTypes = {
  component: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
}
export default PublicRoute
